/* global yaCounter71106010 */
import helpers from '../helpers';
import scrollDepth from 'scroll-depth';

function start15SecTimeout() {
	clearTimeout($(window).data('timeout15Sec'));

	$(window).data('timeout15Sec', setTimeout(() => {
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
	}

	if (window.yaCounter71106010) {
		yaCounter71106010.hit(path);
	}
}

function init(route) {
	return new Promise((resolve) => {
		start15SecTimeout();

		if (route) {
			virtualHit(route.url.path + window.location.search);

			scrollDepth.reset();
		}

		resolve();
	});
}

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: true});
	},
});

helpers.$document
	.on('click', '.kp-logo', () => {
		ga('send', 'event', 'nav', 'kp logo header');
	})
	.on('click', '.bayer-logo', () => {
		ga('send', 'event', 'client link', 'logo header');
	})
	// наведение на инфо о команде
	.on('mouseenter', '.footer__info-button', () => {
		ga('send', 'event', 'nav', 'info footer');
	})
	// выбор страницы
	.on('click', '.intro__item', (e) => {
		const name = helpers.clearText($(e.currentTarget).text());

		if ($(e.currentTarget).closest('.test__final').length) {
			const type = $(e.currentTarget).data('name');

			ga('send', 'event', `test ${type}`, 'go to test', name);
		} else {
			ga('send', 'event', 'main', 'go to test', name);
		}
	})
	// первый показ теста
	.on('show-test-intro', (e, type) => {
		ga('send', 'event', `test ${type}`, 'start', '', {nonInteraction: true});
	})
	// показ шага
	.on('show-test-step', (e, type, num, text) => {
		text = helpers.clearText(text).substring(0, 100);

		ga('send', 'event', `test ${type}`, `question show ${num}`, text, {nonInteraction: true});
	})
	// показ финала
	.on('show-test-final', (e, type, text, count) => {
		text = helpers.clearText(text).substring(0, 100);

		ga('send', 'event', `test ${type}`, 'finish', text, count);
	})
	// клик на кнопку показа вопроса
	.on('click-test-intro-button', (e, type, num, text) => {
		text = helpers.clearText(text).substring(0, 100);

		ga('send', 'event', `test ${type}`, `question button click ${num}`, text, {nonInteraction: true});
	})
	// клик на кнопку ответить
	.on('click-test-answer-button', (e, type, num, text, count) => {
		text = helpers.clearText(text).substring(0, 100);

		ga('send', 'event', `test ${type}`, `question answer ${num}`, text, count);
	})
	// клик на не клиентскую ссылку
	.on('click', '.client-link-other', (e) => {
		const $el = $(e.currentTarget);
		const type = $el.closest('.main').data('name');
		const num = $el.closest('.test__step').data('step');
		const text = $el.closest('.test__step').find('.test__intro p').text();
		const textLink = helpers.clearText(`${$el.text()}`);
		const fullText = `${type} - ${num} - ${text} - ${textLink}`;

		ga('send', 'event', 'test type', 'answer text link click', fullText);
	})
	// клик на клиентскую ссылку
	.on('click', '.client-link, .test__answer-link', (e) => {
		const $el = $(e.currentTarget);
		const type = $el.closest('.main').data('name');
		const num = $el.closest('.test__step').data('step');
		const text = $el.closest('.test__step').find('.test__intro p').text();
		const textLink = helpers.clearText(`${$el.text()}`);
		const fullText = `${type} - ${num} - ${text} - ${textLink}`;
		console.log(fullText);
		ga('send', 'event', 'client link', 'answer text link click', fullText);
	})
	// клик на соц сети на финальном экране
	.on('click', '.intro__share-btn', (e) => {
		const name = $(e.currentTarget).data('social');
		const type = $(e.currentTarget).closest('.main').data('name');

		ga('send', 'event', 'share', `test ${type} final share`, name);
	})
	// клик на соц сети в подвале
	.on('click', '.test__footer-share, .footer__share-btn', (e) => {
		const name = $(e.currentTarget).data('socialy');
		ga('send', 'event', 'share', 'project share footer', name);
	})
	// скип на мобилках
	.on('click', '.js-recomendation-skip', () => {
		ga('send', 'event', 'nav', 'skip rotate');
	})
	// Клик на кнопку "продукация Bayer"
	.on('click', '.intro__link--1', (e) => {
		const type = $(e.currentTarget).closest('.main').data('name');

		ga('send', 'event', 'client link', `test final ${type} bayer button`);
	})
	// Клик на кнопку "Другие маршруты"
	.on('click', '.intro__link--2', (e) => {
		const type = $(e.currentTarget).closest('.main').data('name');

		ga('send', 'event', `test ${type}`, 'other tests button');
	});

export default {
	init,
	virtualHit,
};
